import React,{useEffect} from "react"; 
import { useMap,Marker, Popup } from "react-leaflet";
import L from "leaflet";

const LocationMarker = ({ targetLocation,outsideClick,flyTo, suppressFly = false }) => {
    const map = useMap();
     useEffect(() => {
      if(!targetLocation || outsideClick || !map || suppressFly) return;
      map.flyTo(targetLocation, flyTo ? 13 : 6, {
        duration: 2 // seconds (Leaflet uses seconds, not ms)
      });

     }, [targetLocation, map, outsideClick, flyTo, suppressFly]);
 
     return (
       targetLocation && (
         <>
           {flyTo ? (
             <Marker
               position={targetLocation}
               icon={L.icon({
                 iconSize: [25, 41],
                 iconAnchor: [10, 41],
                 popupAnchor: [2, -40],
                 iconUrl:
                   "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png",
                 shadowUrl:
                   "https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png",
               })}
             >
               <Popup>You are here</Popup>
             </Marker>
           ) : (
             ""
           )}
         </>
       )
     );
  };

  export default LocationMarker;